export const actions = {
    backToStart: "Retourner à l'acceuil",
};
